'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.the-content').length <= 0 ) {
        return
    }

    // Carousel
    if ( $('.carousel').length >= 0 ) {
        const carousel = new Swiper('.carousel-wrapper', {
            wrapperClass: 'carousel',
            slideClass: 'carousel__figure',
            slidesPerView: 1,
            spaceBetween: 50,
            centeredSlides: true,
            pagination: false,
            grabCursor: true,
            parallax: true,
            speed: 1000,
            navigation: {
                prevEl: '.carousel-nav__btn--prev',
                nextEl: '.carousel-nav__btn--next',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                }
            }
        })
    }

    // Youtube
    if ( $('.youtube-block').length >= 0 ) {
        $('.youtube-block').each(function() {
            const player = new Plyr( '#' + $(this).find('.plyr__video-embed').attr('id') )
        })
    }
}
